import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0%, 100% {
    transform: translateY(0px) translateX(0px);
    opacity: 0.7;
  }
  25% {
    transform: translateY(-20px) translateX(10px);
    opacity: 1;
  }
  50% {
    transform: translateY(-10px) translateX(-5px);
    opacity: 0.5;
  }
  75% {
    transform: translateY(-30px) translateX(-10px);
    opacity: 0.8;
  }
`;

export const ParticlesContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  
  .floating-particle {
    position: absolute;
    background: linear-gradient(45deg, rgba(43, 56, 87, 0.6), rgba(197, 51, 123, 0.4));
    border-radius: 50%;
    animation: ${float} 20s ease-in-out infinite;
    opacity: 0.6;
  }
`;

export const Particle = styled.div`
  position: absolute;
  width: ${props => props.size};
  height: ${props => props.size};
  left: ${props => props.left};
  top: ${props => props.top};
  background: linear-gradient(45deg, rgba(43, 56, 87, 0.6), rgba(197, 51, 123, 0.4));
  border-radius: 50%;
  animation: ${float} 15s ease-in-out infinite;
  animation-delay: ${props => props.delay};
  opacity: 0.7;
`;
